import { render, staticRenderFns } from "./APITestPage.vue?vue&type=template&id=5b8b6e07&"
import script from "./APITestPage.vue?vue&type=script&lang=ts&"
export * from "./APITestPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8b6e07')) {
      api.createRecord('5b8b6e07', component.options)
    } else {
      api.reload('5b8b6e07', component.options)
    }
    module.hot.accept("./APITestPage.vue?vue&type=template&id=5b8b6e07&", function () {
      api.rerender('5b8b6e07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/APITestPage.vue"
export default component.exports